import { AxiosResponse } from 'axios';
import { IdType, RequestsType, RequestVM } from 'civil-status/view-models/step-form';
import { ActWizard } from 'shell/models/act-wizard';
import { HttpResponse } from 'shell/models/http-response';

export const transformerActWizard = (
  response: AxiosResponse<HttpResponse<ActWizard>>
): RequestsType => {
  const listResponse = response.data?.payload?.percorsoQuestionarioVOList || [];

  if (listResponse.length === 0) {
    // oggetto vuoto se ultimo step
    const dataToTitle = response.data?.payload?.valoreDominio;
    return {
      idValore: dataToTitle?.key?.idValore,
      descrizioneValore: dataToTitle?.descrizioneValore,
      dateFormationAct: response.data?.payload?.statoCivile?.dataFormazioneAtto || undefined,
    } as RequestsType;
  }

  // per come tornano i dati abbiamo una solo domanda quindi impostiamo il tutto per una domanda
  // e n risposte, è un array perchè se cambiano con n domande possiamo adattarlo facilmente
  const requests: Array<RequestVM> = [
    {
      name: listResponse[0]?.domandaQuestionarioVO?.key?.idDomanda?.toString() || 'name',
      type: listResponse[0]?.domandaQuestionarioVO?.tipoVisualizzazione?.trim() || IdType.Radio,
      request: listResponse[0]?.domandaQuestionarioVO?.testoDomanda || '',
      options: listResponse.map((item) => ({
        id: item.key?.codStepSuccessivo || '0',
        codResponse: item.key?.idRisposta,
        value: item.rispostaQuestionarioVO?.descrizioneBreve || '',
        parte: item.cdParte || '',
        serie1: item.cdSerie1 || '',
        serie2: item.cdSerie2 || '',
        responseData: item,
      })),
    } as RequestVM,
  ];

  return {
    step: listResponse[0]?.key?.codStep ? Number.parseInt(listResponse[0]?.key?.codStep, 10) : 0,
    requests,
    dateFormationAct: response.data?.payload?.statoCivile?.dataFormazioneAtto || undefined,
  };
};
